<div class="global-search-bar-container d-flex align-items-center" [class.ai-on]="aiMode">
	<div class="search-shell">
		<div class="input-group" #pillRef>
			<span class="input-group-text" [class.icon-hidden]="searchText"><span class="far fa-search"></span></span>
			<div *ngIf="!aiMode" class="search-type-selector">
				<button type="button" class="search-type-button" (click)="toggleTypeDropdown()">
					<span class="search-type-code">{{ selectedSearchType.code }}</span>
					<i class="fas fa-caret-down"></i>
				</button>
				<div *ngIf="typeDropdownOpen" class="search-type-menu">
					<div *ngFor="let option of searchTypeOptions" class="search-type-menu-item" [class.selected]="option.code === selectedSearchType.code" (click)="selectSearchType(option)">
						{{ option.label }}
					</div>
				</div>
			</div>
			<div class="search-input-wrap">
				<input #searchInput type="text" class="form-control" autocomplete="off" [(ngModel)]="searchText"
					[placeholder]="aiMode ? (inputFocused ? 'Ask AI — e.g. “payments for job 1234”' : '') : 'Global search...'"
					(focus)="onInputFocus()" (click)="onInputFocus()" (blur)="inputFocused = false"
					(keyup.enter)="onAskAI()" />
				<div class="search-marquee" *ngIf="aiMode && !searchText && !inputFocused" aria-hidden="true">
					<div class="search-marquee-track">
						<span class="seg">{{ examplesText }}</span>
						<span class="seg">{{ examplesText }}</span>
					</div>
				</div>
			</div>
			<span class="beta-tag ai-search-beta" title="AI search is in beta">Beta</span>
				<button type="button" class="ai-ask-button" [class.active]="aiMode"
				[title]="aiMode ? 'AI search on — type a question and press Enter' : 'Switch to AI search'" (click)="toggleAiMode()">
				<i class="fas" [class.fa-sparkles]="!isAsking" [class.fa-spinner-third]="isAsking" [class.fa-spin]="isAsking"></i>
			</button>
		</div>

		<slick-auto-complete *ngIf="!aiMode" #autoComplete [inputRef]="searchInput" [positionRef]="pillRef" textField="displayLabel" [items]="searchResults" (onRefresh)="onSearch($event)" (onSelect)="onSelect($event)">
			<ng-template let-result [slickAutoCompleteListItemTemplate]>
				<div class="global-search-result" [attr.data-type]="result.resultType">
					<div class="gs-icon">
						<i [ngClass]="typeIcon(result.resultType)"></i>
					</div>
					<div class="gs-body">
						<div class="gs-line">
							<span class="primary-text">{{ result.primaryText }}</span>
							<span class="gs-type">{{ typeLabel(result.resultType) }}</span>
						</div>
						<div *ngIf="result.secondaryText" class="secondary-text">{{ result.secondaryText }}</div>
						<div *ngIf="result.tertiaryText" class="tertiary-text">{{ result.tertiaryText }}</div>
						<div *ngIf="result.branchName" class="gs-branch"><i class="far fa-building"></i>{{ result.branchName }}</div>
					</div>
				</div>
			</ng-template>
		</slick-auto-complete>

		<!-- AI mode: our own results panel (slick-auto-complete is type-ahead only). Shows only after Enter.
		     Gated on aiResultsOpen so closing just hides it — focusing the box re-opens the same results. -->
		<div *ngIf="aiMode && aiResultsOpen && (isAsking || aiAnswer || searchResults.length || aiSearched)" class="ai-results-panel">
			<!-- Live steps stay visible after the search finishes; results render underneath. -->
			<div *ngIf="aiSessionId" class="ai-panel-steps">
				<ai-activity [sessionId]="aiSessionId"></ai-activity>
			</div>

			<ng-container *ngIf="!isAsking">
				<div *ngIf="aiAnswer" class="ai-answer">
					<i class="fas fa-sparkles"></i>
					<span class="ai-answer-text" [innerHTML]="renderedAnswer"></span>
				</div>

				<!-- "Next step" suggestions — shown only when the AI needs more info; each runs the search on click. -->
				<div *ngIf="aiSuggestions.length" class="ai-suggestions">
					<button type="button" class="ai-suggestion" *ngFor="let suggestion of aiSuggestions" (click)="askSuggestion(suggestion, $event)" [disabled]="isAsking">
						<i class="far fa-arrow-right ai-suggestion-icon"></i>
						<span>{{ suggestion }}</span>
					</button>
				</div>

				<!-- Header: total match count + minimize (to the floating indicator) + close (hides everything). -->
				<div *ngIf="searchResults.length || aiAnswer" class="ai-results-header">
					<span class="beta-tag">Beta</span>
					<span *ngIf="(totalResults || searchResults.length) > 0" class="ai-results-count"><span class="count-num">{{ totalResults || searchResults.length }}</span> {{ (totalResults || searchResults.length) === 1 ? 'result' : 'results' }}</span>
					<span class="ai-results-actions">
						<button type="button" class="ai-results-action" (click)="collapseToIndicator($event)" title="Minimize"><i class="far fa-window-minimize"></i></button>
						<button type="button" class="ai-results-action" (click)="closeAiResults()" title="Close results"><i class="far fa-times"></i></button>
					</span>
				</div>

				<!-- The one scrolling region (this page's 25); header above and pagination below stay pinned. -->
				<div *ngIf="searchResults.length" class="ai-results-list">
					<div class="global-search-result" *ngFor="let result of searchResults" (click)="onSelect(result)" [attr.data-type]="result.resultType" [class.active]="resultKey(result) === lastSelectedKey">
						<div class="gs-icon">
							<i [ngClass]="typeIcon(result.resultType)"></i>
						</div>
						<div class="gs-body">
							<div class="gs-line">
								<span class="primary-text">{{ result.primaryText }}</span>
								<span class="gs-type">{{ typeLabel(result.resultType) }}</span>
							</div>
							<div *ngIf="result.secondaryText" class="secondary-text">{{ result.secondaryText }}</div>
							<div *ngIf="result.tertiaryText" class="tertiary-text">{{ result.tertiaryText }}</div>
							<div *ngIf="result.branchName" class="gs-branch"><i class="far fa-building"></i>{{ result.branchName }}</div>
						</div>
						<button type="button" *ngIf="!isCorporateUser" class="gs-open" (click)="openInNewWindow(result, $event)" title="Open in new tab"><i class="far fa-up-right-from-square"></i></button>
					</div>
				</div>

				<!-- Pagination — server returns 25 per page; walk through all matches. -->
				<div *ngIf="currentPage > 1 || hasMore" class="ai-pagination">
					<button type="button" class="ai-page-btn" [disabled]="currentPage === 1 || isAsking || isPaging" (click)="prevPage()" title="Previous page"><i class="far fa-chevron-left"></i></button>
					<span class="ai-page-info"><i *ngIf="isPaging" class="far fa-spinner-third fa-spin"></i> Page {{ currentPage }}</span>
					<button type="button" class="ai-page-btn" [disabled]="!hasMore || isAsking || isPaging" (click)="nextPage()" title="Next page"><i class="far fa-chevron-right"></i></button>
				</div>

				<div *ngIf="!aiAnswer && !searchResults.length" class="ai-panel-state">I didn't find any results this time — please be patient with me, as I'm still learning.</div>
			</ng-container>
		</div>

		<!-- Collapsed "results available" pill — floats just below the bar; click it to expand the panel back
		     (the AI answer + results return there), or the × to dismiss it entirely. -->
		<div *ngIf="aiMode && hasAiResults && !aiResultsOpen && aiIndicatorVisible" class="ai-results-collapsed" (click)="reopenResults($event)" [title]="lastAiQuery ? ('Show results for: ' + lastAiQuery) : 'Show results'">
			<i class="far fa-magnifying-glass ai-collapsed-icon"></i>
			<span class="ai-collapsed-count">{{ collapsedLabel }}</span>
			<span class="ai-collapsed-query" *ngIf="lastAiQuery">for &ldquo;{{ lastAiQuery }}&rdquo;</span>
			<button type="button" class="ai-collapsed-close" (click)="closeAiResults($event)" title="Dismiss"><i class="far fa-times"></i></button>
		</div>
	</div>
	<div class="ms-1" style="font-size: 1.4rem">
		<help-icon code="GLOBAL_SEARCH"></help-icon>
	</div>
</div>

<!-- A task / appointment result opens its own dialog instead of navigating. -->
<task-edit-dialog #taskDialogRef></task-edit-dialog>
<appointment-dialog #appointmentDialogRef></appointment-dialog>
